export const SharedActionTypes = {
    SET_CLIENT_LOADING: 'SET_CLIENT_LOADING',
    SET_PAGE_LOADING: 'SET_PAGE_LOADING',
}
